import { Assert } from '@cotera/utilities';
import { Dataset } from './dataset.edit';
import { GraphModel } from '../graph/graph.model';
import { useInScopeModel, useWatchableValue } from '../actions/framework';
import { useTabParams } from '../tab-manager/tab-manager';
import { NotFoundTab } from '../not-found.tab';
import { useTrackRecentActivity } from '../hooks/use-track-recent-activity';

export const DatasetDetail = () => {
  const { id } = useTabParams<{ id: string }>();

  const model = useInScopeModel(GraphModel);
  Assert.assert(model !== null);

  const graph = useWatchableValue(model.graph);

  // Track dataset view
  useTrackRecentActivity({ type: 'dataset', name: id });

  if (!graph.hasSymbol(id)) {
    return (
      <NotFoundTab title="Dataset Not Found" resource={`Dataset "${id}"`} />
    );
  }

  return <Dataset isNew={false} startingEraQl={undefined} id={id} />;
};
